var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-sales-view',{attrs:{"nav-bar-title":"Blue-bike","title":"Blue-bike Voucher 24u","image":"images/bluebike-header.jpg","points":3,"price":"3,75","message":_vm.message,"next-link":"/sales/kbc/ticket/confirmation"}})}
var staticRenderFns = []

export { render, staticRenderFns }